/**
 * @file hooks/useTimeout
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import {useEffect, useCallback, useRef} from 'react';

export interface UseTimeoutReturn {
    set: () => void;
    clear: () => void;
}

export default (callback: () => void, ms: number = 0): UseTimeoutReturn => {
    const timeout = useRef<ReturnType<typeof setTimeout>>();
    const savedCallback = useRef(callback);

    const clear = useCallback(() => {
        timeout.current && clearTimeout(timeout.current);
    }, []);

    const set = useCallback(() => {
        clear();

        timeout.current = setTimeout(() => savedCallback.current(), ms);
    }, [clear, ms]);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (ms >= 0) {
            set();
        }

        return clear;
    }, [ms, set, clear]);

    return {
        set,
        clear
    };
};
